import { render, staticRenderFns } from "./FormPasswordReset.vue?vue&type=template&id=2ee7e97e&"
import script from "./FormPasswordReset.vue?vue&type=script&lang=js&"
export * from "./FormPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee7e97e')) {
      api.createRecord('2ee7e97e', component.options)
    } else {
      api.reload('2ee7e97e', component.options)
    }
    module.hot.accept("./FormPasswordReset.vue?vue&type=template&id=2ee7e97e&", function () {
      api.rerender('2ee7e97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/FormPasswordReset.vue"
export default component.exports